export default __webpack_public_path__ + "static/image01-dbb1ec5b4e5133aa6218f33d4b67050e.png";